// extracted by mini-css-extract-plugin
module.exports = {"chart":"bars-zoom_chart_1qDUa","canvas":"bars-zoom_canvas_1P7EG"};